import PropTypes from 'prop-types';
import React, {
  useCallback, useMemo, useState,
} from 'react';
import UserAssignmentSelector from './UserAssignmentSelector';

import { isDynamicType } from '../workflowHelpers';
import { resolveFormDivisionIds } from '../../formHelpers';

const AUTHOR_HELP = 'Save PDF to the form author\'s files tab';

export default function PDFExportUserSelector({
  sections,
  initialSelected,
  divisionId,
  divisionIds = [],
  onChange,
  additionalOptions = [],
  showFormAuthor,
  isDisplay,
}) {
  // Convert single value to array for UserAssignmentSelector, then back to single
  const getInitialSelected = () => {
    if (!initialSelected) return null;
    return initialSelected;
  };

  const [selected, setSelected] = useState(getInitialSelected());

  const relevantDivisionIds = useMemo(
    () => resolveFormDivisionIds({ divisionIds, divisionId }),
    [divisionIds, divisionId],
  );

  const validUserFieldIdSet = useMemo(() => {
    const userFieldIds = new Set();

    sections.forEach(({ fields = [] }) => {
      fields.forEach((field) => {
        const {
          id: fieldId,
          selectedType,
          configProps: {
            dataType,
            optional,
            numAnswers = 1,
            openLimit,
          } = {},
        } = field;

        const isUserDropdown = (
          (selectedType === 'dropdown' && dataType === 'Users')
          || isDynamicType(field, 'dropdown', 'Users')
        );
        if (
          isUserDropdown
          && optional !== true
          && numAnswers === 1
          && !openLimit
        ) {
          userFieldIds.add(fieldId);
        }
      });
    });

    return userFieldIds;
  }, [sections]);

  const onUserChange = useCallback((newSelected) => {
    setSelected(newSelected);
    onChange(newSelected);
  }, [onChange]);

  return (
    <UserAssignmentSelector
      divisions={relevantDivisionIds}
      onChange={onUserChange}
      selected={selected}
      mode="single"
      showPositions={false}
      type="users"
      text=""
      additionalOptions={additionalOptions}
      sections={sections}
      showFields
      showFormAuthor={showFormAuthor}
      formAuthorHelperText={AUTHOR_HELP}
      hideUsers={false}
      isDisplay={isDisplay}
      validUserFields={validUserFieldIdSet}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
PDFExportUserSelector.propTypes = {
  additionalOptions: PropTypes.array,
  divisionId: PropTypes.string,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
  initialSelected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  sections: PropTypes.array,
  showFormAuthor: PropTypes.bool,
  isDisplay: PropTypes.bool,
};

PDFExportUserSelector.defaultProps = {
  additionalOptions: [],
  divisionId: null,
  divisionIds: [],
  initialSelected: null,
  sections: [],
  showFormAuthor: false,
  isDisplay: false,
};
